export const BACKEND_SERVER_URL = process.env.REACT_APP_BE_URL;

export const superAdminTokenName = "supATH";
